import styles from "./styles.module.scss";
import cn from "classnames";

export const VisionStatement = ({ text, className }) => {
  return (
    <section className={cn(styles.VisionStatement, className)}>
      <div className={styles.outer}>
        <div
          className={styles.inner}
          data-sourceflow-prop="text"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
    </section>
  );
};

export default VisionStatement;
